import { render, staticRenderFns } from "./Big.vue?vue&type=template&id=ad790368&scoped=true&"
import script from "./Big.vue?vue&type=script&lang=js&"
export * from "./Big.vue?vue&type=script&lang=js&"
import style0 from "./Big.vue?vue&type=style&index=0&id=ad790368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad790368",
  null
  
)

export default component.exports